export default function getFullUrl(path) {
  return `${location.protocol}//${location.host}${path}`
}
